"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exports.Accordion = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _hooks = require("../../utils/hooks");

var _AccordionPanel = require("./AccordionPanel");

var _ComponentWrapper = _interopRequireDefault(require("../ComponentWrapper"));

var _Typography = require("../Typography");

var _Layout = require("../Layout");

var _helpers = require("../../utils/helpers");

var _Accordion = require("./Accordion.style");

var _MarkdownRenderer = _interopRequireDefault(require("../MarkdownRenderer"));

var Accordion = function Accordion(_ref) {
  var title = _ref.title,
      content = _ref.content,
      cta = _ref.cta,
      id = _ref.id,
      onAccordionChange = _ref.onAccordionChange;

  var _ref2 = (0, _react.useState)(0),
      _ref3 = _slicedToArray(_ref2, 2),
      activePanel = _ref3[0],
      setActivePanel = _ref3[1];

  var _ref4 = (0, _emotionTheming.useTheme)(),
      breakpoints = _ref4.breakpoints;

  var windowWidth = (0, _hooks.useWindowWidth)();
  var isLargeView = windowWidth >= parseInt(breakpoints.medium, 10);
  var showText = activePanel >= 0 && isLargeView;
  var hasCta = !!cta.url && !!cta.label;
  return /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, {
    columnWidth: 12,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_Accordion.AccordionTitleWrap, null, title && /*#__PURE__*/_react.default.createElement(_Typography.PageTitle, null, title), hasCta && /*#__PURE__*/_react.default.createElement(_Accordion.AccordionButton, Object.assign({
    endIcon: "ChevronRight",
    size: "small",
    variant: "link"
  }, cta), cta.label)), /*#__PURE__*/_react.default.createElement(_Layout.Grid, null, /*#__PURE__*/_react.default.createElement(_Layout.Column, {
    width: [12, null, 4, 4]
  }, content.map(function (information, index) {
    return /*#__PURE__*/_react.default.createElement(_AccordionPanel.AccordionPanel, {
      copy: information.copy,
      eventKey: index,
      heading: information.heading,
      key: "00-".concat(information.heading),
      openPanel: setActivePanel,
      show: activePanel === index,
      isLargeView: isLargeView,
      onAccordionChange: onAccordionChange
    });
  })), /*#__PURE__*/_react.default.createElement(_Accordion.CopyColumn, {
    width: [12, null, 8, 8],
    isLargeView: isLargeView
  }, showText && /*#__PURE__*/_react.default.createElement(_MarkdownRenderer.default, {
    copySize: "medium",
    html: (0, _helpers.ellipsify)(content[activePanel].copy, 1500)
  }))));
};

exports.Accordion = Accordion;
Accordion.propTypes = {
  id: _propTypes.default.string,
  title: _propTypes.default.string,
  content: _propTypes.default.arrayOf(_propTypes.default.shape({
    heading: _propTypes.default.string,
    copy: _propTypes.default.string
  })),
  cta: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  }),
  onAccordionChange: _propTypes.default.func
};
Accordion.defaultProps = {
  id: '',
  title: '',
  content: [],
  cta: {
    label: '',
    url: null
  },
  onAccordionChange: function onAccordionChange() {}
};
var _default = Accordion;
exports.default = _default;